import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { setSessionKey } from '../utils/session';
import { callBillingAPI } from '../utils/api';
import { LogInIcon, AlertCircleIcon } from 'lucide-react';
export function Login() {
  const navigate = useNavigate();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // Set page title
  useEffect(() => {
    document.title = 'Billing System';
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    // Basic validation
    if (!login.trim()) {
      setError('Please enter your login');
      return;
    }
    if (!password.trim()) {
      setError('Please enter your password');
      return;
    }
    setIsLoading(true);
    try {
      // Call the login API
      const response = await callBillingAPI('login', {
        user: login,
        password: password
      });
      // Store the session key in localStorage
      if (response.key) {
        setSessionKey(response.key);
        // Redirect to dashboard after successful login
        // Use window.location.href to force a full page reload
        // This ensures all contexts (DataContext, etc.) reinitialize with the new auth state
        window.location.href = '/';
      } else {
        throw new Error('No session key received from server');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-id="element-1850">
      <div className="w-full max-w-md" data-id="element-1851">
        {/* Logo/Header */}
        <div className="text-center mb-8" data-id="element-1852">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-xl mb-4" data-id="element-1853">
            <LogInIcon className="w-8 h-8 text-white" data-id="element-1854" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1855">Welcome Back</h1>
          <p className="text-gray-500 mt-2" data-id="element-1856">Sign in to your billing account</p>
        </div>

        {/* Login Form */}
        <Card data-id="element-1857">
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1858">
            {error && <div className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-start gap-2" data-id="element-1859">
                <AlertCircleIcon className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-1860" />
                <p className="text-sm text-red-600" data-id="element-1861">{error}</p>
              </div>}

            <Input label="Login" type="text" value={login} onChange={e => setLogin(e.target.value)} placeholder="Enter your login" autoComplete="username" autoFocus data-id="element-1862" />

            <Input label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter your password" autoComplete="current-password" data-id="element-1863" />

            <Button type="submit" className="w-full" isLoading={isLoading} leftIcon={!isLoading ? <LogInIcon className="w-4 h-4" data-id="element-1865" /> : undefined} data-id="element-1864">
              Sign In
            </Button>
          </form>
        </Card>

        {/* Footer */}
        <p className="text-center text-sm text-gray-500 mt-6" data-id="element-1866">
          Billing System v1.0.0
        </p>
      </div>
    </div>;
}